import { AUTH_KEY, ETERNAL_REFRESH_TOKEN } from '../consts/auth'
import ROUTE_PATTERNS from "../consts/routes";

export const removeAuthStorages = (removeEternalRefreshToken = false) => {
    localStorage.removeItem(`${AUTH_KEY}`)
    localStorage.removeItem(`${AUTH_KEY}_refresh`)
    localStorage.removeItem(`${AUTH_KEY}_refresh_time`)
    localStorage.removeItem(`${AUTH_KEY}_state`)
    localStorage.removeItem(`${AUTH_KEY}_type`)
    // eternal refresh token must be removed explicitly by user clicking sign out
    if (removeEternalRefreshToken) {
        localStorage.removeItem(`${ETERNAL_REFRESH_TOKEN}`)
    }
}

// Allows us to set the signIn and signOut functions from outside of a component
// E.g. when we want to sign in with refresh token from the axios interceptor
let authController = {
  signIn: null,
  signOut: null,
};

export const setAuthController = ({ signIn, signOut }) => {
  authController = { signIn, signOut };
};

export const getAuthController = () => authController;

// Centralized, reusable logout routine
// - Clears auth storages
// - Calls react-auth-kit signOut if available
// - Notifies other tabs via storage event
// - Optionally redirects to sign-in
export const logoutUser = ({
  shouldRedirect = true,
  redirectTo = ROUTE_PATTERNS.SIGN_IN,
} = {}) => {
  try {
    const { signOut } = authController || {};
    if (typeof signOut === 'function') {
      signOut();
    }

    // Clear local storages (optionally including eternal refresh token)
    removeAuthStorages(true);

    // Notify other tabs to clear their auth state
    window.dispatchEvent(new StorageEvent('auth-storage'));

    // Redirect if applicable
    if (shouldRedirect && window.location.pathname !== redirectTo) {
      window.location.href = redirectTo;
    }
  } catch {}
}
  